import { IconProps } from "./types";
import React from "react";

export const HandIcon = ({
  className,
  fill = "currentColor",
  width = 24,
  height = 24,
  style = {},
}: IconProps): React.ReactElement => (
  <svg
    height={height}
    width={width}
    viewBox="0 0 24 24"
    className={className}
    style={style}
    fill="none"
  >
    <g>
      <path
        d="M9.75 11.2542V2.25415C9.75 1.85633 9.90804 1.47479 10.1893 1.19349C10.4706 0.912186 10.8522 0.75415 11.25 0.75415C11.6478 0.75415 12.0294 0.912186 12.3107 1.19349C12.592 1.47479 12.75 1.85633 12.75 2.25415V11.2542M3.75 15.0042V6.75415C3.75 6.35633 3.90804 5.9748 4.18934 5.69349C4.47064 5.41219 4.85218 5.25415 5.25 5.25415V5.25415C5.64783 5.25415 6.02936 5.41219 6.31066 5.69349C6.59197 5.9748 6.75 6.35633 6.75 6.75415V12.0042L3.75 15.0042ZM6.75 12.0042V3.75415C6.75 3.35633 6.90804 2.9748 7.18934 2.69349C7.47065 2.41219 7.85218 2.25415 8.25 2.25415C8.64783 2.25415 9.02936 2.41219 9.31066 2.69349C9.59197 2.9748 9.75 3.35633 9.75 3.75415V11.2542L6.75 12.0042ZM12.75 11.301V4.50415C12.75 4.10633 12.908 3.7248 13.1893 3.44349C13.4706 3.16219 13.8522 3.00415 14.25 3.00415V3.00415C14.6478 3.00415 15.0294 3.16219 15.3107 3.44349C15.592 3.7248 15.75 4.10633 15.75 4.50415V15.0042L12.75 11.301Z"
        stroke={fill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.75 15.0016C3.75 20.5047 6.75 23.2516 10.875 23.2516C15 23.2516 16.6739 21.3954 17.625 19.1266L20.0958 12.3766C20.408 11.5305 20.2664 10.7458 19.5394 10.3329C18.8119 9.91942 17.8561 10.1322 17.4623 10.8804L15.75 15.0016"
        stroke={fill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);
